// eslint-disable-next-line import/no-anonymous-default-export
export default {
  aiManage: {
    serviceManagement: {
      name: "Service Name",
      aliasName: "Server Alias",
      version: "Version",
      trialLimited: "Trial Times",
      status: "Status",
      changeStatusSuccessfully: "Service Status Changed Successfully",
      changeStatusFailed: "Service Status Changed Failed",
      aihubServiceName: "AI Center Service Name",
    },

    userManagment: {
      ssoIdentityUid: "SsoIdentityUid",
      accountType: "AccountType",
      status: "Status",
      enable: "Enable",
      disable: "Disable",
      prepaid: "Prepaid",
      noprepaid: "Pay As You Go",
      isSaas: "Privatization",
      machineCode: "Machine Code",
      true: "True",
      false: "False",
      validate: {
        inputSsoId: "Please enter the SsoIdentityUid",
        inputName: "Please enter the name",
        inputEmail: "Please enter the email",
        inputPhone: "Please enter the phone",
        selectStatus: "Please select the status",
        selectAccountType: "Please select the accountType",
        email: "The format of the mailbox is incorrect",
        phone: "The format of the phone is incorrect",
      },
    },

    userServiceManagement: {
      name: "Service Management",
      tip: "Tip",
      overdue: "Access_token has expired, please login again!",
      note: "Note: Click 'Confirm' to return to the login page",
      scale:
        "The maximum number of calls cannot be lower than 0 and cannot be higher than 9999999",
      createService: {
        searchName: "Name, Email, or Phone",
        type: "Type",
        formal: "Formal",
        trial: "Trial",
        maxCallLimited: "MaxCallLimited",
        used: "Used",
        tip: "Tip：Please check before filling in Services",
        tiptop: "Please enter your name, email address, or mobile phone number",
      },
      editService: {
        key: "secret Key",
        keyOne: "Key One",
        keyTwo: "Key Two",
        retrieveKeyOne: "Retrieve Key One",
        retrieveKeyTwo: "Retrieve Key Two",
        used: "Used",
        tip: "Please complete the service",
        tiptop: "Please make sure the name or service is filled in",
      },
      common: {
        inputName: "Please enter the name",
        inputEmail: "Please enter the email",
        inputPhone: "Please enter the phone",
        copyOne: "Key One is copied successfully",
        copyTwo: "Key Two is copied successfully",
      },
    },
  },
};
